import {
    FETCH_LAYERS_REQUEST,
    FETCH_LAYERS_SUCCESS,
    FETCH_LAYERS_FAILURE,

    FETCH_LAYER_REQUEST,
    FETCH_LAYER_SUCCESS,
    FETCH_LAYER_FAILURE,

    SET_BASE_LAYER,
    SET_LAYER_SELECTED_LAYER_FROM_SEARCH
} from './Types';

import axios from 'axios';
import _ from 'lodash';
import { setFilter } from '../layer_settings/Actions';
import { buildLegendSpecification } from './Helper';

const CancelToken = axios.CancelToken;
let cancelFetchLayers;
let cancelFetchLayer;

const fetchLayers = () => ({ type: FETCH_LAYERS_REQUEST });
const fetchLayersSuccess = (layers, baseLayers, searchLayers) => ({ type: FETCH_LAYERS_SUCCESS, layers, baseLayers, searchLayers });
const fetchLayersError = (error) => ({ type: FETCH_LAYERS_FAILURE, error });

const fetchLayer = () => ({ type: FETCH_LAYER_REQUEST });
const fetchLayerSuccess = (layer) => ({ type: FETCH_LAYER_SUCCESS, layer });
const fetchLayerError = (error) => ({ type: FETCH_LAYER_FAILURE, error });

export const setBaseLayer = (baseLayer) => ({ type: SET_BASE_LAYER, baseLayer });

function formatBaseLayers (baseLayers) {
    const formattedBaseLayers = [...baseLayers];
    // Compute baselayers that are composed of other baselayers
    for (const baseLayer of formattedBaseLayers) {
        const compose = baseLayer.styling.compose;
        if (compose) {
            let mapbox = null;
            let layersMap = {};
            for (const blConfig of compose.baselayers) {
                const sourceBaseLayer = formattedBaseLayers.find(layer => layer.system_name === blConfig.name);
                if (sourceBaseLayer) {
                    const sourceMapbox = sourceBaseLayer.styling.mapbox;
                    if (sourceMapbox) {
                        if (mapbox === null) {
                            // just clone the first composed layer
                            mapbox = _.cloneDeep(sourceMapbox);
                            mapbox.layers = [];
                            mapbox.name = baseLayer.name;
                            mapbox.id = baseLayer.system_name;
                        } else {
                            // add additional composed layers to the first one
                            mapbox.sources = {
                                ...mapbox.sources,
                                ...sourceMapbox.sources
                            };
                        }

                        for (const layer of _.cloneDeep(sourceMapbox.layers)) {
                            if (layersMap[layer.id] === undefined) {
                                // adjust layer zoom limits
                                if (layer.minzoom === undefined || layer.minzoom < blConfig.minzoom) { layer.minzoom = blConfig.minzoom; }
                                if (layer.maxzoom === undefined || layer.maxzoom > blConfig.maxzoom) { layer.maxzoom = blConfig.maxzoom; }
                                if (layer.maxzoom >= layer.minzoom) {
                                    layersMap[layer.id] = layer;
                                    mapbox.layers.push(layer);
                                }
                            }
                        }
                    }
                }
            }

            baseLayer.styling.mapbox = mapbox;
        }
    }
    return formattedBaseLayers;
}

export const fetchLayersAsync = () => {
    return (dispatch, getState) => {
        cancelFetchLayers && cancelFetchLayers();
        dispatch(fetchLayers());
        return axios.get('/api/layers', {
            cancelToken: new CancelToken((c) => { cancelFetchLayers = c; })
        }).then(response => {
            for (const layer of response.data.layers) {
                // ToDo: When the layers load, set the default filters as well, would be better to set before they are first turned on
                const settings = getState().layerSettingsReducer.find(setting => setting.uid === layer.system_name);
                const defaultTree = layer.filterConfig && layer.filterConfig.defaultTree;
                if (defaultTree && !(settings && settings.filters)) {
                    dispatch(setFilter(layer.system_name, defaultTree));
                }
                // ToDo: When the layers load, set the legend specification for the styles, would be better on the backend
                for (const style of layer.styles) {
                    if (style.legendSpecification === null || style.legendSpecification.length === 0) {
                        style.legendSpecification = buildLegendSpecification(style, layer.name, layer.system_name);
                    }
                }
            }
            dispatch(fetchLayersSuccess(response.data.layers, formatBaseLayers(response.data.base_layers), response.data.search_layers));
        }).catch(error => {
            dispatch(fetchLayersError(error.response));
        });
    };
};

export const fetchLayerAsync = (id) => {
    return (dispatch, getState) => {
        cancelFetchLayer && cancelFetchLayer();
        dispatch(fetchLayer());
        return axios.get(`api/layer/${id}`, {
            cancelToken: new CancelToken((c) => { cancelFetchLayer = c; })
        }).then(response => {
            const layer = response.data;
            dispatch(fetchLayerSuccess(layer));
            const settings = getState().layerSettingsReducer.find(setting => setting.uid === layer.system_name);
            const defaultTree = layer.filterConfig && layer.filterConfig.defaultTree;
            if (defaultTree && !(settings && settings.filters)) {
                dispatch(setFilter(layer.system_name, defaultTree));
            }
        }).catch(error => {
            dispatch(fetchLayerError(error.response));
        });
    };
};

export const setLayerSelectedLayerFromSearch = ({ category, systemName }) => ({ type: SET_LAYER_SELECTED_LAYER_FROM_SEARCH, category, systemName });